import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import styles from './AmazonPushModal.module.css';

// Backdrop component
const Backdrop = (props) => {
  return <div className={styles.backdrop} onClick={props.onClose} />;
};

// Modal overlay component
const ModalOverlay = (props) => {
  return (
    <div className={styles.modal} style={{ maxWidth: '500px' }}>
      <header className={styles.header}>
        <h2>{props.title || 'Validation Error'}</h2>
        <button onClick={props.onClose} className={styles.closeButton} aria-label="Close Modal">
          <FaTimes />
        </button>
      </header>
      
      <div className={styles.content}>
        <p style={{ margin: 0, textAlign: 'center', fontSize: '1rem', lineHeight: '1.6' }}>
          {props.message || 'Please fix the validation error to proceed.'}
        </p>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button onClick={props.onClose} className={styles.gotItButton}>
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};

// Main Modal component using React Portals
const AmazonValidationModal = (props) => {
  // Check if running in a browser environment before accessing document
  if (typeof window === 'undefined') {
    return null;
  }

  const portalElement = document.getElementById('modal-root');

  // Ensure the portal element exists before attempting to create a portal
  if (!portalElement) {
    return null;
  }

  // Only render if show is true
  if (!props.show) {
    return null;
  }

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        portalElement
      )}
      {ReactDOM.createPortal(
        <ModalOverlay onClose={props.onClose} title={props.title} message={props.message} />,
        portalElement
      )}
    </React.Fragment>
  );
};

export default AmazonValidationModal;
